  <product-chooser #productChooser [displayStyle]="'DropDown'"
  ></product-chooser>



// WEBPACK FOOTER //
// ./src/app/toolboxes/product-chooser-toolbox/product-chooser-toolbox.component.html